import { RepositoryError } from './errors';
import {notify} from '../utils';

// handleRequestError wraps the handling of axios request failures.
const handleRequestError = (error) => {
    throw error;
};

// handleResponseError wraps the handling of axios response errors.
const handleResponseError = (error) => {
    const status = error.response.status;
    let message = '';
    switch (status) {
        case 401:
            message = 'Your session has expired. Please refresh the page and login again to continue.';
            break;
        case 403:
            message = 'You do not have permissions to access this.';
            break;
        case 404:
            message = 'Not found.';
            break;
        case 503:
            message = 'Acadia is temporarily unavailable for maintenance. Please try again in a few minutes.';
            break;
        default:
            if(error.response.data.errors) {
                if(typeof error.response.data.errors === 'object') {
                    message = JSON.stringify(error.response.data.errors);
                } else {
                    message = error.response.data.errors;
                }
            }
            else if(error.response.data.message) {
                message = error.response.data.message;
            }
            else if(error.response.data) {
                message = JSON.stringify(error.response.data)
            }
            else {
                message = 'An error has occurred.';
            }
            break;
    }
    throw new Error(`${message}`);
};

// default error handler for our http repositories
export default error => {
    // 400x || 500x
    if (error.response) {
        return handleResponseError(error);
    }

    // error making request
    if (error.request) {
        return handleRequestError(error);
    }

    // axios config error
    throw error;
};
